export function handleChangePositions(name, x, y) {
    const positions = localStorage.getItem('gatewayWidgetsPositions');
    if (!positions) {
        const p = {};
        p[name] = { x, y };
        localStorage.setItem('gatewayWidgetsPositions', JSON.stringify(p));
    }
    else {
        const newPositions = JSON.parse(positions);
        newPositions[name] = { x, y };
        localStorage.setItem('gatewayWidgetsPositions', JSON.stringify(newPositions));
    }
}
export function getWidgetPositions(name) {
    const result = { x: 0, y: 0 };
    const positionsObject = localStorage.getItem('gatewayWidgetsPositions');
    if (!positionsObject)
        return result;
    if (!JSON.parse(positionsObject)[name])
        return result;
    return {
        x: JSON.parse(positionsObject)[name].x,
        y: JSON.parse(positionsObject)[name].y
    };
}
